module.exports = __webpack_public_path__ + "img/comparethemarket.91709edd.png";